export default __webpack_public_path__ + "static/media/sponsor-icon-active.e0461e2d.webp";